import { Controller } from "stimulus"
import Chart from "chart.js"

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    nominal: Array,
    real: Array,
    usd: Array,
    hasIpc: Boolean,
    hasUsd: Boolean
  }

  connect() {
    this.renderChart()
  }

  renderChart() {
    const ctx = this.canvasTarget.getContext('2d')
    const datasets = []

    // Nominal (ARS) - left axis
    datasets.push({
      label: 'Nominal (ARS)',
      data: this.nominalValue,
      borderColor: '#007bff',
      backgroundColor: 'rgba(0, 123, 255, 0.1)',
      borderWidth: 2.5,
      pointRadius: 4,
      pointBackgroundColor: '#007bff',
      lineTension: 0.3,
      yAxisID: 'yARS',
      fill: false
    })

    // Paridad IPC CABA - left axis
    if (this.hasIpcValue && this.realValue.length > 0) {
      datasets.push({
        label: 'Paridad IPC CABA',
        data: this.realValue,
        borderColor: '#28a745',
        backgroundColor: 'rgba(40, 167, 69, 0.1)',
        borderWidth: 2.5,
        borderDash: [6, 3],
        pointRadius: 4,
        pointBackgroundColor: '#28a745',
        lineTension: 0.3,
        yAxisID: 'yARS',
        fill: false
      })
    }

    // USD (Blue) - right axis
    if (this.hasUsdValue && this.usdValue.length > 0) {
      datasets.push({
        label: 'USD (Blue)',
        data: this.usdValue,
        borderColor: '#fd7e14',
        backgroundColor: 'rgba(253, 126, 20, 0.1)',
        borderWidth: 2.5,
        pointRadius: 4,
        pointBackgroundColor: '#fd7e14',
        pointStyle: 'triangle',
        lineTension: 0.3,
        yAxisID: 'yUSD',
        fill: false
      })
    }

    // Chart.js v2 scales config uses yAxes/xAxes arrays
    const yAxes = [
      {
        id: 'yARS',
        type: 'linear',
        position: 'left',
        ticks: {
          beginAtZero: false,
          fontColor: '#007bff',
          callback: function(value) { return '$' + value.toLocaleString('es-AR') }
        },
        scaleLabel: {
          display: true,
          labelString: 'ARS ($)',
          fontColor: '#007bff',
          fontStyle: 'bold'
        },
        gridLines: { color: 'rgba(0, 123, 255, 0.08)' }
      }
    ]

    if (this.hasUsdValue && this.usdValue.length > 0) {
      yAxes.push({
        id: 'yUSD',
        type: 'linear',
        position: 'right',
        ticks: {
          beginAtZero: false,
          fontColor: '#fd7e14',
          callback: function(value) { return 'US$' + value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 1 }) }
        },
        scaleLabel: {
          display: true,
          labelString: 'USD (Blue)',
          fontColor: '#fd7e14',
          fontStyle: 'bold'
        },
        gridLines: { drawOnChartArea: false }
      })
    }

    new Chart(ctx, {
      type: 'line',
      data: { labels: this.labelsValue, datasets: datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 1000 },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex]
              var label = dataset.label || ''
              var value = tooltipItem.yLabel
              if (value == null) return null
              if (dataset.yAxisID === 'yUSD') {
                return label + ': US$' + value.toLocaleString('es-AR', { minimumFractionDigits: 2 })
              }
              return label + ': $' + value.toLocaleString('es-AR')
            }
          }
        },
        legend: {
          labels: { usePointStyle: true, padding: 20 }
        },
        scales: {
          yAxes: yAxes,
          xAxes: [{
            gridLines: { color: 'rgba(0, 0, 0, 0.05)' }
          }]
        }
      }
    })
  }
}
